import { isNil } from "lodash";
import { selector, selectorFamily } from "recoil";

import { ProcessStatusEnum } from "../../enums";
import { IRydeProcess, TActiveProcessKey } from "../../models";
import { activeProcessesAtom, processAtom } from "../atoms";

export const processSelector = selector<Map<number, IRydeProcess>>({
  key: "processesSelector",
  get: ({ get }) => get(processAtom),
});

export const activeProcessSF = selectorFamily<
  IRydeProcess | null,
  TActiveProcessKey
>({
  key: "activeProcessSF",
  get:
    key =>
    ({ get }) => {
      const activeProcesses = get(activeProcessesAtom);
      const activeProcessId = activeProcesses?.get(key);

      if (isNil(activeProcessId)) {
        return null;
      }

      const processes = get(processAtom);

      const process = processes.get(activeProcessId);

      if (!process) {
        return null;
      }

      return process;
    },
});

export const processStatusSF = selectorFamily<
  ProcessStatusEnum | null,
  TActiveProcessKey
>({
  key: "processStatusSF",
  get:
    key =>
    ({ get }) => {
      const activeProcess = get(activeProcessSF(key));

      return activeProcess ? activeProcess.status : null;
    },
});

export const isProcessPendingSF = selectorFamily<boolean, TActiveProcessKey>({
  key: "isProcessPendingSF",
  get:
    key =>
    ({ get }) => {
      const processStatus = get(processStatusSF(key));

      return processStatus === ProcessStatusEnum.Pending;
    },
});
